module.exports = __webpack_public_path__ + "static/media/stellaColor3.c73c5a4c.jpg";